import React, { useEffect, useState } from "react";
import { GoogleMap, Marker, LoadScript } from "@react-google-maps/api";

type LatLng = { lat: number; lng: number };

interface MapPickerProps {
  apiKey: string;
  center: LatLng;
  onSelect: (location: LatLng) => void;
  zoom?: number;
  markerLabel?: string;
}

const containerStyle = {
  width: "100%",
  height: "350px",
};

const MapPicker: React.FC<MapPickerProps> = ({
  apiKey,
  center,
  onSelect,
  zoom = 14,
  markerLabel = "",
}) => {
  const [position, setPosition] = useState<LatLng>(center);

  useEffect(() => {
    setPosition(center);
  }, [center]);

  const handleMapClick = (event: google.maps.MapMouseEvent) => {
    if (!event.latLng) return;

    const coords = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    };

    setPosition(coords);
    onSelect(coords);
  };

  return (
    <LoadScript googleMapsApiKey={apiKey}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={position}
        zoom={zoom}
        onClick={handleMapClick}
        options={{
          disableDefaultUI: false,
          clickableIcons: false,
          mapTypeControl: false,
          streetViewControl: false,
        }}
      >
        <Marker
          position={position}
          label={markerLabel}
        />
      </GoogleMap>
    </LoadScript>
  );
};

export default MapPicker;
